import { Directive, EventEmitter, HostBinding, HostListener, Output } from "@angular/core";

@Directive({
  selector: "[appDropZone]",
})
export class DropZoneDirective {
  @HostBinding("class.fileover") fileOver: boolean;
  @Output() fileDropped: EventEmitter<any> = new EventEmitter<any>();

  // Dragover listener
  @HostListener("dragover", ["$event"]) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = true;
  }

  // Dragleave listener
  @HostListener("dragleave", ["$event"]) onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
  }

  // Dragover listener
  @HostListener("drop", ["$event"]) onDrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;

    let files = evt.dataTransfer.files;

    if (files.length > 0) this.fileDropped.emit(evt);
  }
}

